import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { AiOutlineIdcard } from "react-icons/ai";
import { BsClockHistory } from "react-icons/bs";
import { MdErrorOutline } from "react-icons/md";

import halfday from "../../assets/images/half-time.svg";
const Rwabulkexcelattendance = () => {
  const [groupedJson, setGroupedJson] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewCount, setPreviewCount] = useState(0);
  const currentYear = new Date().getFullYear();
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [years, setYears] = useState(currentYear.toString());
  const currentMonth = new Date().getMonth() + 1;
  const [months, setMonths] = useState(currentMonth.toString());
  const { password, username } = billpunchbasicauth;
  const handleFile = async (e) => {
    setError("");
    setSuccess("");
    setGroupedJson(null);
    setPreviewCount(0);

    const file = e.target.files[0];
    if (!file) return;

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });

      const result = {};
      let r = 0;

      while (r < rows.length) {
        const row = rows[r].map((c) =>
          c === null || c === undefined ? "" : String(c).trim()
        );

        const empIdx = row.findIndex(
          (cell) =>
            /^Employee\s*Code[:]?$/i.test(cell) ||
            /^Employee\s*Code/i.test(cell)
        );

        if (empIdx !== -1) {
          let empcode = "";
          for (let k = empIdx + 1; k < row.length; k++) {
            if (row[k] !== "") {
              empcode = row[k];
              break;
            }
          }

          if (!empcode) {
            let rr = r + 1;
            while (rr < rows.length && !empcode) {
              const row2 = rows[rr].map((c) =>
                c === null || c === undefined ? "" : String(c).trim()
              );
              for (let k = 0; k < row2.length; k++) {
                if (row2[k] !== "" && !/Employee\s*Name/i.test(row2[k])) {
                  empcode = row2[k];
                  break;
                }
              }
              rr++;
              if (rr - r > 4) break;
            }
          }

          empcode = empcode.toString();

          let headerRow = -1;
          let headerMap = {};

          for (let j = r + 1; j < Math.min(rows.length, r + 30); j++) {
            const rr = rows[j].map((c) =>
              c === null || c === undefined ? "" : String(c).trim()
            );
            const joined = rr.join(" ").toLowerCase();

            if (
              joined.includes("date") &&
              (joined.includes("intime") ||
                joined.includes("in time") ||
                joined.includes("in")) &&
              (joined.includes("outtime") ||
                joined.includes("out time") ||
                joined.includes("out"))
            ) {
              headerRow = j;
              for (let ci = 0; ci < rr.length; ci++) {
                const cell = rr[ci].toString().toLowerCase();
                if (cell.includes("date")) headerMap.date = ci;
                if (
                  cell.includes("intime") ||
                  cell === "in" ||
                  cell.includes("in time")
                )
                  headerMap.in = ci;
                if (
                  cell.includes("outtime") ||
                  cell === "out" ||
                  cell.includes("out time")
                )
                  headerMap.out = ci;
                if (cell.includes("status")) headerMap.status = ci;
              }
              break;
            }
          }

          if (headerRow !== -1) {
            if (!result[empcode]) result[empcode] = [];

            for (let x = headerRow + 1; x < rows.length; x++) {
              const rr = rows[x].map((c) =>
                c === null || c === undefined ? "" : String(c).trim()
              );
              const joined = rr.join(" ").toLowerCase();

              if (
                joined.includes("total duration") ||
                joined.includes("employee code") ||
                joined.startsWith("total ")
              ) {
                r = x;
                break;
              }

              const nonEmpty = rr.filter((c) => c !== "");
              if (nonEmpty.length === 0) {
                r = x;
                break;
              }

              const dateVal =
                headerMap.date !== undefined ? rr[headerMap.date] : rr[0];
              if (!dateVal || String(dateVal).toLowerCase().includes("total")) {
                continue;
              }

              const inVal = headerMap.in !== undefined ? rr[headerMap.in] : "";
              const outVal =
                headerMap.out !== undefined ? rr[headerMap.out] : "";
              const statusVal =
                headerMap.status !== undefined ? rr[headerMap.status] : "";

              result[empcode].push({
                date: dateVal,
                in_time: inVal,
                out_time: outVal,
                status: statusVal,
              });

              setPreviewCount((prev) => prev + 1);
            }
          } else {
            r++;
          }
        } else {
          r++;
        }
      }

      const formattedArray = Object.keys(result).map((empCode) => ({
        employee_code: empCode,
        employee_name: empCode, // change if you have real name
        employee_designation: "",
        total_halfday: 0,
        total_late: 0,
        attendance_map: convertToDateMap(
          result[empCode].map((r) => ({
            attendance_date: r.date,
            in_time: r.in_time,
            out_time: r.out_time,
            attendance_status: r.status,
          })),
          years,
          months
        ),
      }));
      
      setGroupedJson(formattedArray);
    } catch (err) {
      console.error(err);
      setError("Failed to parse file: " + (err.message || err));
    }
  };

  const handleUpload = async () => {
    if (!groupedJson || !Array.isArray(groupedJson) || groupedJson.length === 0) {
      setError("Please upload and parse an Excel file first.");
      return;
    }
  
    setTransactionLoaderState(true);
    setError("");
    setSuccess("");
  
    try {
      // 🔄 Convert UI Format → API Format
      const apiPayload = {};
  
      groupedJson.forEach((emp) => {
        if (!emp.employee_code || !emp.attendance_map) return;
  
        const empCode = emp.employee_code.toString();
        const attendanceArray = [];
  
        Object.keys(emp.attendance_map).forEach((day) => {
          const att = emp.attendance_map[day];
  
          // Skip completely empty rows
          if (!att) return;
          if (!att.in_time && !att.out_time && !att.status) return;
  
          attendanceArray.push({
            date: day,
            in_time: att.in_time || "",
            out_time: att.out_time || "",
            status: att.status || "",
          });
        });
  
        // Only attach if attendance exists
        if (attendanceArray.length > 0) {
          apiPayload[empCode] = attendanceArray;
        }
      });
  
      console.log("Final API Payload:", apiPayload);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertEmployeeExcelAttendanceRaw`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(apiPayload), // ✅ correct structure
        }
      );
  
      const data = await res.json();
      console.log("API Response:", data);
  
      if (data.status === "0") {
        setSuccess("✅ Attendance data uploaded successfully!");
      } else {
        setError("Upload failed: " + (data.msg || "Unknown error"));
      }
    } catch (err) {
      console.error(err);
      setError("API request failed: " + (err.message || err));
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const convertToDateMap = (attendanceList, year, month) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    const result = {};
  
    for (let i = 1; i <= daysInMonth; i++) {
      const d = String(i).padStart(2, "0");
      result[d] = { in_time: "", out_time: "", status: "" };
    }
  
    attendanceList.forEach((a) => {
      if (!a.attendance_date) return;
  
      const day = a.attendance_date.split("-")[0].padStart(2, "0");
  
      result[day] = {
        in_time: a.in_time || "",
        out_time: a.out_time || "",
        status: a.attendance_status || "",
      };
    });
  
    return result;
  };

  const fetchRawAttendance = async () => {
    setTransactionLoaderState(true);
    setError("");
    setSuccess("");

    try {
      const res = await fetch(
        `https://payroll.billpunch.com/api/SuperAdmin/GetRawAttendance?firmid=${user?.firm_id}&month=${months}&year=${years}`,
        {
          method: "POST", // MUST BE GET (your API does not accept POST)
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      console.log("Raw Attendance Response:", data);

      if (data.status === "0") {
        setSuccess("Attendance fetched successfully!");

        const finalData = data.data.map((emp) => {
          // Parse string JSON
          let list = JSON.parse(emp.attendance_list);

          // SORT BY DATE PROPERLY
          list.sort(
            (a, b) => new Date(a.attendance_date) - new Date(b.attendance_date)
          );

          // Map to correct 01–31 structure
          const mappedDates = convertToDateMap(list, years, months);

          return {
            ...emp,
            attendance_map: mappedDates, // Ready for UI mapping
          };
        });

        setGroupedJson(finalData);
      } else {
        setError(data.msg || "Failed to load attendance.");
      }
    } catch (err) {
      setError("API Error: " + err.message);
    }

    setTransactionLoaderState(false);
  };
  const dayList = React.useMemo(() => {
    if (!months || !years) return [];

    const totalDays = new Date(years, months, 0).getDate();
    const arr = [];

    for (let d = 1; d <= totalDays; d++) {
      const day = d < 10 ? `0${d}` : `${d}`;
      arr.push(day);
    }

    return arr;
  }, [months, years]);

  return (
    <div className="m-3">
      <div className="row mt-4">
        <div className="col-md-10 col-12 p-0 d-flex align-items-center">
          <div className="px-md-2">
            <select
              value={years}
              style={{
                width: "7rem",
                height: "2rem",
                borderRadius: ".4rem",
                border: "1px #ced4da solid",
              }}
              onChange={(e) => setYears(e.target.value)}
            >
              <option value="" disabled>
                Select Year
              </option>{" "}
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
            </select>
          </div>
          <div className="px-md-2">
            <select
              value={months}
              style={{
                width: "7rem",
                height: "2rem",
                borderRadius: ".4rem",
                border: "1px #ced4da solid",
              }}
              onChange={(e) => setMonths(e.target.value)}
            >
              <option value={2023}>Month</option>
              <option value={1}>January</option>
              <option value={2}>February</option>
              <option value={3}>March</option>
              <option value={4}>April</option>
              <option value={5}>May</option>
              <option value={6}>June</option>
              <option value={7}>July</option>
              <option value={8}>August</option>
              <option value={9}>September</option>
              <option value={10}>October</option>
              <option value={11}>November</option>
              <option value={12}>December</option>
            </select>
          </div>
          <button
            onClick={fetchRawAttendance}
            className="btn btn-primary btn-sm"
            style={{ marginLeft: "10px" }}
          >
            Fetch Attendance
          </button>
        </div>
        <div className="col d-flex justify-content-end">
          <Link to="/admin/attendance-management">
            <Button
              className="btn-sm"
              style={{
                cursor: "pointer",
                border: "1px solid",
                backgroundColor: "rgba(43, 193, 85, 0.1)",
                color: "rgba(43, 193, 85, 1)",
                bordercolor: "rgba(43, 193, 85, 1)",
                borderRadius: ".4rem",
              }}
            >
              Back
            </Button>
          </Link>
        </div>
      </div>
      <div className="card p-3 ">
        <h5>Raw Attendance bmnb</h5>
        <input
          className="form-control"
          type="file"
          accept=".xls,.xlsx"
          onChange={handleFile}
        />
      </div>
      {groupedJson && (
        <div className="mt-3">
          <div className="accordion" id="attendanceAccordion">
          {Array.isArray(groupedJson) &&
  groupedJson.map((emp, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`emp-${index}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        flexGrow: 1,
                        whiteSpace: "nowrap", 
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <b>{emp.employee_name}</b>{" "}
                      <span style={{ fontSize: ".8rem" }}>
                        ({emp.employee_designation})
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "18px",
                        alignItems: "center",
                        whiteSpace: "nowrap", 
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>
                      Half Day -
                        <span style={{ marginLeft: "6px" }}>
                          {emp.total_halfday}
                        </span>
                      </span>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        Late - 
                        <span style={{ marginLeft: "6px" }}>
                          {emp.total_late}
                        </span>
                      </span>
                      &nbsp;
                    </div>
                  </button>
                </h2>

                <div
                  id={`collapse-${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#attendanceAccordion"
                >
                  <div className="accordion-body">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {dayList.map((d) => (
                              <th key={d}>{d}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
  <tr>
    {dayList.map((d) => {
      const att = emp.attendance_map[d] || {};
      let statusText = "";
      let statusColor = "";

      if (att.status === "Y") {
        statusText = "Present";
        statusColor = "green";
      } else if (att.status === "N") {
        statusText = "Absent";
        statusColor = "red";
      }

      return (
        <td 
          key={d} 
          style={{ fontSize: '12px', textAlign: 'center' }}
        >
          {att.in_time || att.out_time || att.status ? (
            <>
              {att.in_time || "-"} - {att.out_time || "-"} (
              <span style={{ color: statusColor }}>{statusText}</span>)
            </>
          ) : (
            "-"
          )}
        </td>
      );
    })}
  </tr>
</tbody>


                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {groupedJson && (
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Parsed JSON (grouped)</h5>
            <div>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={handleUpload}
                disabled={loading}
              >
                {loading ? "Uploading..." : "Upload to Server"}
              </button>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-md-4">
              <div className="list-group">
                {Object.keys(groupedJson).map((key) => (
                  <button
                    key={key}
                    className="list-group-item list-group-item-action"
                    onClick={() => {
                      const el = document.getElementById("json-preview");
                      el.textContent = JSON.stringify(
                        { [key]: groupedJson[key] },
                        null,
                        2
                      );
                    }}
                  >
                    {key} ({groupedJson[key].length})
                  </button>
                ))}
              </div>
            </div>
            <div className="col-md-8">
              <pre
                id="json-preview"
                className="json-output border rounded p-2 bg-light"
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  fontSize: "13px",
                }}
              >
                {JSON.stringify(groupedJson, null, 2)}
              </pre>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default Rwabulkexcelattendance;
